import { PAYMENT_SUMMARY } from "..";
import { apiInstance } from "../config/apiInstance";

export type PaymentSummaryRequest = {
  eDocumentIds: number[];
};

export type PaymentSummaryProvider = {
  id: number | null;
  name: string;
  code: string;
  employerIdNumber: string;
};

export type PaymentSummaryPaymentLine = {
  id: number | null;
  code: string;
  name: string;
};

export type PaymentSummaryCostCenter = {
  id: number | null;
  code: string;
  name: string;
};

export type PaymentSummaryDetail = {
  id: number | null;
  conceptCode: string;
  conceptDescription: string;
  provider: PaymentSummaryProvider;
  valor: number;
  operatingIndicator: string;
  costCenter: PaymentSummaryCostCenter[];
  cdp: string | null;
  rcp: string | null;
  materialCode: string;
};

export type PaymentSummaryResponse = {
  id: number | null;
  consecutive: string;
  paymentAuthorizationTotalValue: number;
  provider: PaymentSummaryProvider;
  paymentLine: PaymentSummaryPaymentLine;
  details: PaymentSummaryDetail[];
};

export const postPaymentSummary = async (
  data: PaymentSummaryRequest,
): Promise<PaymentSummaryResponse> => {
  const response = await apiInstance.post<PaymentSummaryResponse>(
    PAYMENT_SUMMARY,
    data,
    {
      headers: {
        "X-Timezone-Id": "America/Bogota",
        "Accept-Language": "es-CO",
      },
    },
  );
  return response.data;
};
